import { Model } from "../model";
import { VariableType } from "./variable-type";
import { VariableTypeVisibility } from "./variable-type-visibility";
import { VariableTypeComponent } from "./variable-type-component";
import { VariableOption } from "./variable-option";
import { VariableLegend } from "./variable-legend";
import { VariableValue } from "./variable-value";

export class Variable implements Model {
    _id: string;
    environmentId: string;
    code: string;
    description: string;
    optional: boolean;
    type: VariableType;
    typeVisibility: VariableTypeVisibility;
    typeComponent: VariableTypeComponent;
    decimals?: number;
    minValue?: number;
    maxValue?: number;
    suffix?: string;
    defaultValue?: VariableValue;
    reportFormula?: string;
    inspectionFormula?: string;
    legend?: VariableLegend;
    options?: VariableOption[];
    placeholder?: string
}